export const SITE_NAME = 'Poziom 511 Jura Wellness Hotel & SPA'

export const SITE_DESCRIPTION =
  'Poziom 511 Jura Wellness Hotel & SPA położony jest w samym sercu Jury Krakowsko-Częstochowskiej, u stóp Zamku Ogrodzieniec. Komfortowe pokoje hotelowe, basen, strefa SPA&Wellness, restauracja, sale konferencyjne i wiele więcej. Zapraszamy!'

export const SITE_OG_IMAGE = {
  url: 'https://www.poziom511.pl/static/img/poziom.jpeg',
  width: 1200,
  height: 1200,
  type: 'image/jpeg',
  alt: 'Poziom',
}
